module.exports = __webpack_public_path__ + "img/left-circle.232abe53.png";